/* Dashboard */
export const GET_USERDASHBOARD = "GET_USERDASHBOARD"
export const GET_USERDASHBOARD_SUCCESS = "GET_USERDASHBOARD_SUCCESS"
export const GET_USERDASHBOARD_FAIL = "GET_USERDASHBOARD_FAIL"

export const GET_REPORTDASHBOARD = "GET_REPORTDASHBOARD"
export const GET_REPORTDASHBOARD_SUCCESS = "GET_REPORTDASHBOARD_SUCCESS"
export const GET_REPORTDASHBOARD_FAIL = "GET_REPORTDASHBOARD_FAIL"

